export default __webpack_public_path__ + "static/move-milestone-d48323c3949427b6a90eb6d264596a28.mp4";